var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu",attrs:{"id":"menu"}},[_c('ul',[_c('li',{on:{"click":_vm.handelSureCancel}},[_c('i',{staticClass:"el-icon-refresh-right"}),_vm._v("撤销打款 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }